<template>
  <div id="login" class="bg-primary">
    <a-row>
      <a-col :span="24" :xxl="{span:6, offset:9}" :xl="{span:8, offset:8}" :lg="{span:12, offset:6}"
             :md="{span:16, offset:4}">
        <a-card title="学会网站平台——会员登录"
                :bordered="false"
                style="width: 100%;margin:4rem 0"
                :headStyle="{textAlign:'center', fontWeight:'bolder',fontSize:'1.5rem'}">
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-form-model-item ref="username" label="账号" prop="username">
              <a-input
                placeholder="手机号/会员号/统一信用代码"
                v-model="form.username"
                @blur="
          () => {
            $refs.username.onFieldBlur();
          }"/>
              <span class="text-danger">{{errors.username}}</span>
            </a-form-model-item>
            <a-form-model-item ref="password" label="密码" prop="password">
              <a-input-password v-model="form.password" placeholder="请输入密码"/>
              <span class="text-danger" v-if="errors.password">{{errors.password}}</span>
              <span class="text-danger" v-if="errors.error">{{errors.error}}</span>
            </a-form-model-item>

            <a-form-model-item label="会员类型" prop="part">
              <a-radio-group v-model="form.part">
                <a-radio value="P">
                  个人会员
                </a-radio>
                <a-radio value="O">
                  团体会员
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item>

            </a-form-model-item>

            <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }" style="text-align: center">
              <a-button type="primary" @click="onSubmit">
                登录
              </a-button>
              <a-button style="margin-left: 10px;" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>

            <div style="margin: 24px">
              <router-link :to="{name:'register'}" class="text-primary">个人会员申请</router-link>
              <router-link :to="{name:'registerCompany'}" class="text-primary float-right">团队会员申请</router-link>
            </div>

          </a-form-model>
          <a-card-footer class="text-muted">
            <div class="text-center">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;版权所有@2021 沈阳华睿博信息技术有限公司
            </div>
          </a-card-footer>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {createUserPerson, login} from "../../api/api";
import cookie from "../../../static/js/cookie";

export default {
  name: "Login",
  data() {
    return {
      labelCol: {span: 6},
      wrapperCol: {span: 14},
      errors: {
        error: '',
        username: '',
        password: '',
      },
      form: {
        username: '',
        password: '',
        part: 'P'
      },
      rules: {
        username: [{required: true, message: '登录账号不能为空', trigger: 'blur'}],
        password: [{required: true, message: '密码不能为空', trigger: 'blur'}],
        part: [
          {required: true, message: '请选择会员类型', trigger: 'change'},
        ],
      },
    }
  },
  mounted() {
    var h = document.documentElement.clientHeight || document.body.clientHeight
    var a = document.getElementById('login')
    a.style.height = h + 'px'
  },
  methods: {
    onSubmit() {
      this.errors = {
        username: '',
        password: ''
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          var that = this;
          login(this.form)
            .then((response) => {
              console.log('=== 登录响应数据 ===');
              console.log('response.data:', response.data);

              // ✅ 提取数据
              const data = response.data;
              const userId = data.user_id || data.uid || data.id;
              const memberId = data.member_id;
              const membershipId = data.membership_id || data.mid;

              console.log('userId:', userId);
              console.log('memberId:', memberId);
              console.log('membershipId:', membershipId);

              // ✅ 存储到 cookie
              cookie.setCookie('name', data.name || data.username, 7);
              cookie.setCookie('token', data.token, 7);
              cookie.setCookie('part', data.part || 'P', 7);
              cookie.setCookie('user_id', userId, 7);
              cookie.setCookie('uid', userId, 7);
              cookie.setCookie('id', userId, 7);
              cookie.setCookie('member_id', memberId, 7);
              cookie.setCookie('mid', membershipId, 7);

              // ✅ 更新 store 数据
              that.$store.dispatch('setInfo', {
                name: data.name || data.username,
                token: data.token,
                part: data.part || 'P',
                user_id: userId,
                uid: userId,
                id: userId,
                member_id: memberId,
                mid: membershipId,
                membership_id: membershipId,
              });

              // ✅ 获取个人或团体信息
              if (this.form.part === 'P') {
                that.$store.dispatch('setPerson');
              } else {
                that.$store.dispatch('setOrg');
              }

              if (this.$store.getters.url) {
                that.$router.replace({path: this.$store.getters.url})
              } else {
                that.$router.push({name: 'scf'})
              }
            })
            .catch(function (error) {
                console.log('===== 完整错误对象 =====');
                console.log('error:', error);
                console.log('error 类型:', typeof error);
                console.log('error 键:', Object.keys(error));
                console.log('========================');
               if (error.error === '用户审核未通过') {
                  alert('⚠️ 您的账号审核未通过，请联系管理员处理');
                  return;
                }
              if ("username" in error) {
                that.errors.username = error.username[0];
              }
              if ("password" in error) {
                that.errors.password = error.password[0];
              }
              if ("non_field_errors" in error) {
                that.errors.error = '用户名或密码错误';
              }

            });
        } else {
          console.log('验证失败!!');
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  }
}
</script>

<style scoped>
a:hover {
  color: rebeccapurple;
}
</style>



// WEBPACK FOOTER //
// src/components/sign/Login.vue